/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { NavLink } from "react-router-dom";
import { resourcesLinks, websiteLinks } from "components/footer/main-footer/link-data";
import { ReactComponent as ExternalLinkIcon } from "cms/assets/icons/external-link.svg";

const ResourcesColumn = () => {
    return (
        <div className='footer-column resources-column'>
            <div className='resources-container'>
                <h2>Resources</h2>
                <ul>
                    {resourcesLinks && resourcesLinks.map((link, idx) => {
                        const linkTitle = link?.title ?? "";
                        const linkURL = link?.url ?? "";
                        return (
                            <li key={`resources-link-${idx}`}>
                                <NavLink to={linkURL}>
                                    {linkTitle}
                                </NavLink>
                            </li>
                        );
                    })}
                </ul>
            </div>
            <div className='websites-container'>
                <h2>Our Websites</h2>
                <ul>
                    {websiteLinks && websiteLinks.map((link, idx) => {
                        const linkTitle = link?.title ?? "";
                        const linkURL = link?.url ?? "";
                        return (
                            <li key={`website-link-${idx}`}>
                                <a href={linkURL} target='_blank' rel="noopener noreferrer">
                                    <span>{linkTitle}</span><ExternalLinkIcon />
                                </a>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

export { ResourcesColumn };
